

























import Component from 'vue-class-component'
import BasicComponent from "@/global/BasicComponent";
import {Prop} from "vue-property-decorator";
import {ProductDto} from "@swagger";

@Component({
  components: {}
})
export default class ConfigurationModeSelector extends BasicComponent {

  @Prop(String) value: string;
  @Prop(Object) product: ProductDto;

  mounted() {
  }

  onSelect(event): void {
    this.$emit("input", event);
    this.$emit("select");
  }

  get autoChoiceSettingLabel(): string {
    const types = [...new Set(this.flattenArray(this.product.imageRequirements.map(r => r.types)))];
    const names = types.map(t => this.$t("IMAGE_NAME_" + t));
    const concat = this.replaceLast(names.join(", "), ",", " &");
    if (types.length > 1) {
      return this.$t("CONFIGURATOR_MODE_AUTO_MULTIPLE_DESCRIPTION").toString().replace("{images}", concat);
    } else {
      return this.$t("CONFIGURATOR_MODE_AUTO_SINGLE_DESCRIPTION").toString().replace("{image}", concat);
    }
  }

  get detailedChoiceSettingLabel(): string {
    let label = this.$t('CONFIGURATOR_MODE_DETAILED_DESCRIPTION').toString();
    if (this.product.detailedConfigurationSurcharge > 0) {
      label += ` (+ ${this.formatPrice(this.product.detailedConfigurationSurcharge)})`;
    }
    return label;
  }

}

